import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AddCircleBlue, CustomDelete, FullTable } from 'components';
import {PermissionList, RolePermission, sortListByKey, useModal} from 'utils';
import { adminActions } from 'store';
import { CLIENT_ASSIGN_ACTION_TYPE, clientAssignmentBody, clientAssignmentHead, clientAssignmentNotYet } from './constants';
import { AssignClientToStaff } from './modals';

const REMOVE_ACTION_TYPE = 'UNASSIGN_CLIENT_FORM_STAFF';

export const StaffAssignment = ({}) => {
    const staffClients = useSelector((state) => state.admins.staffClients);
    const { staffGeneral } = useSelector((state) => ({ staffGeneral: state.admins.adminInfoById }));
    const dispatch = useDispatch();
    const params = useParams();
    const { open, close } = useModal();

    useEffect(() => {
        dispatch(adminActions.getAssignedStaffClients(params?.id));
    }, []);

    const handleClickButton = (item, name) => {
        if (name === 'delete') {
            open(
                <CustomDelete
                    text={`Are you sure you want to unassign this client from the staff?`}
                    info="Unassign Client?"
                    innerText={'Unassign'}
                    handleDel={() => dispatch(adminActions.unAssignClientToStaff(item?.assignedId, staffGeneral?.id))}
                    handleClose={() => close()}
                    actionType={REMOVE_ACTION_TYPE}
                />
            );
        }
        if (name === 'edit') {
            open(<AssignClientToStaff item={item} />);
        }
    };

    return (
        <div className="assign-staff-client-wrapper">
            {RolePermission([PermissionList.CLIENT_STAFF_ASSIGNMENT?.code]) &&
            <div className="header-action-btn">
                <AddCircleBlue text={'Assign Client'} handleClick={() => open(<AssignClientToStaff />)} />
            </div>
            }
            <FullTable
                head={clientAssignmentHead}
                body={clientAssignmentBody}
                loadingType={CLIENT_ASSIGN_ACTION_TYPE}
                list={sortListByKey(staffClients, 'clientName')}
                handleClickButton={handleClickButton}
                notYet={clientAssignmentNotYet}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
